var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "23px",
    viewBox: "0 0 26 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F134370E-F9C1-4721-9EEE-04A24E71778D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1440,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Courtesy-Hold-Payment-Failure-@1440--Copy",
    transform: "translate(-461.000000, -94.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notifications/payment-failed/1440",
    transform: "translate(444.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/system/error",
    transform: "translate(18.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Error_940617",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.496,17.9688571 L13.7294286,1.05228571 C13.372,0.433428571 12.7117143,0.0522857143 11.9971429,0.0522857143 C11.2825714,0.0522857143 10.6222857,0.433428571 10.2648571,1.05228571 L0.428,18.0905714 C0.0708571429,18.7094286 0.0708571429,19.4717143 0.428,20.0905714 C0.785428571,20.7094286 1.44571429,21.0905714 2.16028571,21.0905714 L21.8342857,21.0905714 C21.8362857,21.0905714 21.8385714,21.0905714 21.84,21.0905714 C22.9445714,21.0905714 23.84,20.1951429 23.84,19.0905714 C23.8397143,18.6748571 23.7131429,18.2885714 23.496,17.9688571 Z",
    id: "Path",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,5.93628571 C12.6171429,5.93628571 13.1177143,6.43657143 13.1177143,7.054 L12.832,13.72 C12.8034286,14.3228571 12.3348571,14.552 12,14.552 C11.6248571,14.552 11.2008571,14.3542857 11.168,13.72 L10.8822857,7.054 C10.8822857,6.43657143 11.3828571,5.93628571 12,5.93628571 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0085714,17.9314286 C12.7454286,18.1971429 12.3768571,18.3485714 12,18.3485714 C11.6228571,18.3485714 11.2542857,18.1971429 10.9885714,17.9314286 C10.7228571,17.6657143 10.5714286,17.2971429 10.5714286,16.92 C10.5714286,16.5428571 10.7228571,16.1771429 10.9885714,15.9114286 C11.2542857,15.6457143 11.6228571,15.4914286 12,15.4914286 C12.3768571,15.4914286 12.7454286,15.6457143 13.0085714,15.9114286 C13.2771429,16.1771429 13.4285714,16.5457143 13.4285714,16.92 C13.4285714,17.2971429 13.2771429,17.6657143 13.0085714,17.9314286 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.91ee873e009197f64d7aafd2cc8c2720.svg";
export { ForwardRef as ReactComponent };